<template>
  <div class="print-preview-modal">
    <a-table :columns="formData.columns" :dataSource="formData.dataSource" :pagination="false" :expandedRowKeys="expandedRowKeys" rowKey="id" bordered :class="expandedRowKeys.length>0?'' :'table-last-child'">
      <span v-for="(item,index) in formData.columns" :key="index" :slot="item.slots.title" class="table-title">
        {{ item.slots.value }}
      </span>
      <template slot="productName" slot-scope="text, record" v-if="record.productName">
        <div class="image-assembly-flag">
          <span v-if="record.giftFlag==1" style="padding-right: 5px">（赠品）</span>
          <span>{{ text }}</span>
        </div>
      </template>
      <template slot="title">
        <div class="company-logo-name">
          <img :src="formData.printTitle.imgIcon" class="image-logo" v-show="formData.printTitle.imgIcon" />
          <span>{{ formData.printTitle.company }}</span>
        </div>
        <div class="print-page-title" style="display: flex;align-items: center;justify-content: center;">
          <span>{{ formData.printTitle.title }}</span>
        </div>
        <div class="top-list-box top-list-box-top">
          <div class="top-list" v-for="(item,index) in formData.topArray" :key="index">
            <div class="top-list-text" v-if="item.isShow">
              <span class="title">{{ item.title?item.title+'：' :''  }}</span>
              <span class="value">{{ item.value }}</span>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="top-list-box top-list-box-footer">
          <div class="top-list" v-for="(item,index) in formData.bottonArray" :key="index">
            <div class="top-list-text" v-if="item.isShow">
              <span class="title">{{ item.title }}：</span>
              <span class="value">{{ item.value }}</span>
            </div>
          </div>
        </div>
        <div class="custom-content-preview">
          <span v-html="formData.custom.content"></span>
        </div>
        <div class="signature" v-for="(item,index) in formData.footerArry" :key="index">
          <span class="title" @click="item.isInput=true">{{ item.title+'：' }}</span>
          <span class="value"></span>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    templateType:{
      type: Number,
      default: 101
    }
  },
  data() {
    return {
      formDataView:{},
      expandedRowKeys:[]
    };
  },
  mounted() {},
  methods: {

  },
  watch: {
    formData() {
      this.formDataView = this.formData
      if(this.templateType==506) {
        this.expandedRowKeys = []
        this.formData.dataSource.map((one, onenum) => {
          one.children = one.sonFinanceIncomeStatementVOList;
          this.expandedRowKeys.push(one.id);
          if (one.sonFinanceIncomeStatementVOList.length > 0) {
            one.sonFinanceIncomeStatementVOList.map((two, twonum) => {
              two.children = two.sonFinanceIncomeStatementVOList;
              this.expandedRowKeys.push(two.id);
              if (two.sonFinanceIncomeStatementVOList.length > 0) {
                two.sonFinanceIncomeStatementVOList.map((three, threenum) => {
                  three.children = three.sonFinanceIncomeStatementVOList;
                  this.expandedRowKeys.push(three.id);
                });
              }
            });
          }
        })
      }
    }
  }
};
</script>
<style lang="scss">
.print-preview-modal {
  width: 100%;
  background-color: #ffffff;
  // padding: 0 36px 20px 36px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-weight: 100 !important;
  font-family: "Microsoft STFangsong", 华文仿宋;
  .ant-table-wrapper {
    flex: 1;
    padding: 10px 0;
    width: 100%;
    .ant-table-title {
      border: 0 !important;
      color: #000000 !important;
      padding: 10px 0 !important;
    }
    .image-assembly-flag {
      display: flex;
      align-items: center;
      .image {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
    .ant-table-body {
      border-color: #000000 !important;
      border-bottom: 1px solid #000000;
      table {
        border-color: #000000 !important;
      }
      .ant-table-thead {
        display: table-header-group;
        tr {
          height: auto !important;
        }
      }
      tr {
        th {
          height: auto !important;
          height: auto !important;
          background-color: #ffffff;
          border-color: #000000 !important;
          padding: 2px 10px !important;
          font-size: 14px !important;
          color: #000000 !important;
          text-align: center;
        }
      }
      tr {
        td {
          height: auto !important;
          background-color: #ffffff;
          border-color: #000000 !important;
          padding: 2px 10px !important;
          font-size: 14px !important;
          color: #000000 !important;
          text-align: center;
        }
      }
    }
    .ant-table-footer {
      padding: 20px 0;
    }
    .ant-table-row-expand-icon {
      opacity: 0;
    }
  }
  .company-logo-name {
    font-size: 14px;
    .image-logo {
      width: 36px;
      height: 36px;
      margin-right: 16px;
    }
  }
  .print-page-title {
    width: 100%;
    font-size: 18px;
    position: relative;
    padding-bottom: 16px;
    color: #000000 !important;
  }
  th:nth-child(1){
    width: 28%;
  }
  th:nth-child(2){
    width: 30%;
  }
  .top-list-box-top {
    .top-list {
      margin-right: 0;
    }
    .top-list:nth-child(3n-2){
        width: 45%;
    }
    .top-list:nth-child(3n+3){
        width: 21.6%;
    }
  }
  .top-list-box-footer {
    padding-bottom: 10px;
    .top-list {
      width: 33.3%;
    }
  }
  .top-list-box {
    width: 100%;
    overflow: hidden;
    .top-list {
      width: 33.3%;
      float: left;
      padding: 3px 0;
      .top-list-text {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #000000 !important;
      }
    }
  }
  .signature {
    width: 33%;
    height: 20px;
    float: left;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin: 8px 0;
    font-size: 14px !important;
    color: #000000 !important;
    .value {
      height: 20px;
      display: inline-block;
      width: 30%;
      border-bottom: 1px solid #333333;
    }
  }
  .custom-content-preview {
    font-size: 14px;
    margin-top: 16px;
    color: #000000 !important;
    padding-bottom: 20px;
  }
}
</style>
